import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { ListEntityField } from "models/list-entity-field";

export type FormSubmitFunction = (values: FormValues) => Promise<void>;

// more detailed typing might be needed
export type FormAction = string;

export type FormValues = Record<string, string | number>;

// create COMPLETE set of answers as FormValue type from all the answers
export const toFormValues = (
  entityCollectionValues: EntityCollectionValue[],
  listEntityFields: ListEntityField[],
): FormValues => {
  // create formValues object
  const formValues: FormValues = {};
  entityCollectionValues.forEach((collectionValue) => {
    const { list_entity_field_uuid, data } = collectionValue;
    formValues[list_entity_field_uuid] = data.value || "";
  });

  // make sure the object contains a key for every field
  listEntityFields.forEach((entityField) => {
    if (formValues[entityField.uuid] === undefined) {
      // check is a special child
      if (entityField.datatype === "check") {
        formValues[entityField.uuid] = "no";
        return;
      }

      // for all the other fields
      formValues[entityField.uuid] = "";
    }
  });

  // return form values
  return formValues;
};

// get ecvs updated with form values
export const fromFromValues = (
  entityCollectionValues: EntityCollectionValue[],
  formValues: FormValues,
) => {
  // create a new array for added or changed values
  const newEntityCollectionValues: Partial<EntityCollectionValue>[] = [];

  // uuid here is list_entity_field_uuid
  for (const list_entity_field_uuid in formValues) {
    const value = formValues[list_entity_field_uuid] || "";

    // get the existing entityFieldValue with the uuid
    const ecv: Partial<EntityCollectionValue> | undefined =
      entityCollectionValues.find(
        (ecv) => ecv.list_entity_field_uuid === list_entity_field_uuid,
      );

    if (!ecv) {
      // if we don't have an existing field value
      newEntityCollectionValues.push({
        list_entity_field_uuid,
        data: { value: value },
      });
    } else {
      // just update the value
      newEntityCollectionValues.push({
        ...ecv,
        data: { value },
      });
    }
  }

  // all done
  return newEntityCollectionValues;
};

// this is used to cast FormValues to per form FormModel
function cast<FormModel>(formValues: FormValues): FormModel {
  return formValues as unknown as FormModel;
}

export { cast };
